<template>
  <div @keyup.13="submit">
    <mu-dialog
      title="编辑产品"
      width="500"
      :open="open"
      @close="close"
      class="update-dialog"
      scrollable
    >
      <mu-form :model="editForm" label-position="left" label-width="100">
        <mu-form-item prop="name" label="名称">
          <!-- <mu-text-field v-model="editForm.name"></mu-text-field> -->
          <mu-auto-complete
            :data="nameList"
            :max-search-results="8"
            v-model="editForm.name"
            open-on-focus
          ></mu-auto-complete>
        </mu-form-item>

        <mu-form-item prop="specification" label="规格">
          <mu-text-field
            v-model="editForm.specification"
            help-text="长*宽,单位mm"
          ></mu-text-field>
        </mu-form-item>

        <mu-form-item prop="thickness" label="厚度">
          <mu-text-field
            v-model="editForm.thickness"
            help-text="mm"
          ></mu-text-field>
        </mu-form-item>

        <mu-form-item prop="weight" label="重量" v-if="!isSimple">
          <mu-text-field
            v-model="editForm.weight"
            help-text="kg"
          ></mu-text-field>
        </mu-form-item>

        <mu-form-item prop="materialPrice" label="材料单价">
          <mu-text-field
            v-model="editForm.materialPrice"
            help-text="元/kg"
          ></mu-text-field>
        </mu-form-item>

        <mu-form-item prop="materialSum" label="材料总价" error-text="元">
          <mu-text-field v-model="editForm.materialSum"></mu-text-field>
        </mu-form-item>

        <mu-form-item prop="laserLength" label="切割长度" v-if="!isSimple">
          <mu-text-field
            v-model="editForm.laserLength"
            help-text="米"
          ></mu-text-field>
        </mu-form-item>

        <mu-form-item prop="laserPrice" label="切割单价" v-if="!isSimple">
          <mu-text-field
            v-model="editForm.laserPrice"
            help-text="元/米"
          ></mu-text-field>
        </mu-form-item>

        <mu-form-item
          prop="laserSum"
          label="切割总价"
          :error-text="`元,${isSimple ? '切割+穿孔' : '不含穿孔'}`"
        >
          <mu-text-field v-model="editForm.laserSum"></mu-text-field>
        </mu-form-item>

        <mu-form-item prop="kongCount" label="穿孔数量" v-if="!isSimple">
          <mu-text-field
            v-model="editForm.kongCount"
            help-text="个"
          ></mu-text-field>
        </mu-form-item>

        <mu-form-item prop="kongPrice" label="穿孔单价" v-if="!isSimple">
          <mu-text-field
            v-model="editForm.kongPrice"
            help-text="元/个"
          ></mu-text-field>
        </mu-form-item>

        <mu-form-item
          prop="kongSum"
          label="穿孔总价"
          v-if="!isSimple"
          error-text="元"
        >
          <mu-text-field v-model="editForm.kongSum"></mu-text-field>
        </mu-form-item>

        <mu-form-item prop="bendSum" label="折弯总价" error-text="元">
          <mu-text-field v-model="editForm.bendSum"></mu-text-field>
        </mu-form-item>

        <mu-form-item prop="unit" label="单位">
          <mu-select v-model="editForm.unit">
            <mu-option
              v-for="(item, index) in unitList"
              :key="index"
              :value="item"
              :label="item"
            ></mu-option>
          </mu-select>
        </mu-form-item>

        <mu-form-item prop="isBYO" label="是否自带料">
          <mu-switch
            v-model="editForm.isBYO"
            :label="editForm.isBYO ? '是' : '否'"
          ></mu-switch>
        </mu-form-item>

        <mu-form-item prop="price" label="单价" error-text="元">
          <mu-text-field v-model="editForm.price"></mu-text-field>
        </mu-form-item>

        <mu-form-item prop="count" label="数量">
          <mu-text-field v-model="editForm.count"></mu-text-field>
        </mu-form-item>

        <mu-form-item prop="sum" label="总价" error-text="元">
          <mu-text-field v-model="editForm.sum"></mu-text-field>
        </mu-form-item>

        <mu-form-item prop="pic" label="图片">
          <div
            class="pic-upload"
            :contenteditable="editForm.pic === ''"
            @paste="paste"
            v-loading="imgLoading"
          >
            <img :src="editForm.pic" v-if="editForm.pic" />
            <mu-button
              fab
              color="red"
              class="delete-button"
              small
              @click="editForm.pic = ''"
              v-if="editForm.pic"
            >
              <mu-icon value="clear"></mu-icon>
            </mu-button>
            <div class="placeholder" v-else>将图片复制至此处</div>
          </div>
        </mu-form-item>
      </mu-form>
      <mu-switch slot="actions" v-model="isSimple" label="简易模式"></mu-switch>
      <mu-button slot="actions" flat color="secondary" @click="close"
        >取消</mu-button
      >
      <mu-button
        slot="actions"
        color="primary"
        @click="submit"
        v-loading="loading"
        >提交</mu-button
      >
    </mu-dialog>
  </div>
</template>

<script>
import backend from 'utils/backend'
import api from '@/api'
import numeral from 'numeral'
export default {
  props: {
    open: {
      tpye: Boolean,
      default: false
    },
    form: {
      type: Object
    }
  },
  data() {
    return {
      isSimple: true,
      editForm: {},
      imgLoading: false,
      loading: false,
      unitList: ['件', '套', '米', '平米', '公斤'],
      thicknessList: [
        1, 1.2, 1.5, 2, 3, 4, 5, 6, 8, 10, 12, 14, 16, 18, 20, 25, 30
      ],
      nameList: []
    }
  },
  methods: {
    submit() {
      this.loading = true
      backend(api.product.update, this.editForm).then((result) => {
        this.loading = false
        if (result.statusCode === 200) {
          this.close()
          this.$emit('finish', result.data)
        }
      })
    },
    close() {
      this.$emit('update:open', false)
    },
    paste(e) {
      e.preventDefault()
      if (e.clipboardData.types[0] === 'Files') {
        const file = e.clipboardData.items[0].getAsFile()
        this.picUpload(file)
      }
    },
    picUpload(file) {
      this.imgLoading = true
      const formData = new FormData()
      formData.append('file', file)
      backend(api.product.picUpload, formData).then((result) => {
        this.imgLoading = false
        if (result.statusCode === 200) {
          this.editForm.pic = result.data.url
        }
      })
    },
    nameListInit() {
      const list = []
      this.thicknessList.forEach((item) => {
        list.push(item + 'mm碳钢')
        list.push(item + 'mm不锈钢')
        list.push(item + 'mm铝板')
      })
      this.nameList = list
    }
  },
  watch: {
    open(val) {
      if (val) {
        this.editForm = JSON.parse(JSON.stringify(this.form))
      }
    },
    'editForm.price': {
      handler(val) {
        this.editForm.sum = numeral(this.editForm.count)
          .multiply(this.editForm.price)
          .value()
      },
      deep: true
    },
    'editForm.count': {
      handler(val) {
        this.editForm.sum = numeral(this.editForm.price)
          .multiply(this.editForm.count)
          .value()
      },
      deep: true
    }
  },
  mounted() {
    this.nameListInit()
  }
}
</script>

<style lang="less" scoped>
.update-dialog {
  .pic-upload {
    width: 100%;
    height: 300px;
    border: 2px dashed #ddd;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    .delete-button {
      position: absolute;
      top: 0px;
      right: 0px;
    }
    img {
      max-width: 100%;
      max-height: 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/product/update.vue